import { useAtomValue } from 'jotai';
import { useLocalStorage } from 'react-use';

import { Heading, Tag } from '@growtherapy/sprout-ui';

import {
  ClientMeasureOptOutBannerConnected,
  ClientMeasureOptOutReminderBannerConnected,
} from '@grow-therapy-team/seedling-components';

import {
  CSSRSFormListItemWrapper as CSSRSFormListItem,
  IntakeFormListItemWrapper as IntakeFormListItem,
  MeasuresFormListItemWrapper as MeasuresFormListItem,
  SafetyPlanFormListItemWrapper as SafetyPlanFormListItem,
} from '../measures/FormListItems';
import { selectedClientUserShortIdAtom } from '../state';
import {
  CLIENT_OPT_OUT_REMINDER_BANNER_DISMISSED,
  CLIENT_OPT_OUT_REMINDER_BANNER_DISMISSED_VALUE,
  MEASURES_AND_FORMS_TITLE,
} from './constants';
import { CombinedFormDataEntriesByFormTitle } from './types';

type ClientInformationFormsAndQuestionnairesProps = {
  completedForms?: CombinedFormDataEntriesByFormTitle;
  hasNewForms?: boolean;
  isInSessionWithSelectedClient?: boolean;
  shouldShowAnytimeCSSRS?: boolean;
};
export function ClientInformationFormsAndQuestionnaires({
  hasNewForms,
  isInSessionWithSelectedClient,
  shouldShowAnytimeCSSRS,
}: ClientInformationFormsAndQuestionnairesProps) {
  const clientUserShortId = useAtomValue(selectedClientUserShortIdAtom);

  const [clientOptOutReminderBannerDismissed, setClientOptOutReminderBannerDismissed] = useLocalStorage(
    CLIENT_OPT_OUT_REMINDER_BANNER_DISMISSED,
    'false',
  );
  // TODO: [CARED-3259] Once new seedlings hook is available, also check if client is too young to complete the CSSRS
  const shouldShowCSSRS = isInSessionWithSelectedClient && shouldShowAnytimeCSSRS;

  return (
    <div className='flex flex-col' data-testid='client-info.measures-and-forms'>
      <Heading variant='lg' className='mb-8' as='h3'>
        {MEASURES_AND_FORMS_TITLE}
        {hasNewForms && (
          <Tag aria-label='Client has new forms' use='lilac' className='ml-2'>
            New
          </Tag>
        )}
      </Heading>
      <>
        {clientUserShortId && (
          <ClientMeasureOptOutReminderBannerConnected
            renderContext='provider'
            clientUserShortId={clientUserShortId}
            handleClose={() => setClientOptOutReminderBannerDismissed(CLIENT_OPT_OUT_REMINDER_BANNER_DISMISSED_VALUE)}
            isClosed={clientOptOutReminderBannerDismissed === CLIENT_OPT_OUT_REMINDER_BANNER_DISMISSED_VALUE}
            baseBanner={
              <ClientMeasureOptOutBannerConnected clientUserShortId={clientUserShortId} renderContext='telehealth' />
            }
          />
        )}
        {shouldShowCSSRS && <CSSRSFormListItem />}
        <MeasuresFormListItem />
        <IntakeFormListItem />
        <SafetyPlanFormListItem />
      </>
    </div>
  );
}
